import { IBuildingSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export function getFloor(floorNumber: number, building: IBuildingSchema | null) {
  const mapFloorNumberToFloorQueryValue: { [key: number]: string } = {
    1: 'floorOne',
    2: 'floorTwo',
  };

  const isLastFloor = Boolean(building && building.floorsCount === floorNumber);

  if (isLastFloor) {
    return 'floor=floorLast';
  }

  const floor = mapFloorNumberToFloorQueryValue[floorNumber];

  return `floor=${floor ? floor : 'floorOther'}`;
}
